<body>
  <div class="partical_all">
    <!--<div id="stars"></div>-->
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div id="particle-container">
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
      <div class="particle"></div>
    </div>
  </div>
  <div class="container-fluid fade_one">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(nov11)/images/logo_one.png"
            alt="logo"
          />
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-4 sec">
        <div class="right_box">
          <div class="launching_box">
            <div class="launching_box_one">
            
              <h1 class="ml2">LAUNCHING SOON!</h1>
            </div>
            <div class="text_box">
              <div class="slider">
                <p>
                  Not sure of the path you're taking in life? Change the course
                  of your life while we guide you to your success. ONPASSIVE is
                  a digital marketing platform that offers millions of people
                  with business opportunities to embark their presence in the
                  modern era. Find what suits you the best and get on board
                  before it is too late.
                </p>
              </div>
            </div>

            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="button pulse"
            >
              Become a Founder
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 top_one">
        <div class="mid_box">
          <div class="mid_image">
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(nov11)/images/mid_image_three.png"
              alt="image"
            />
          </div>
          <div class="round_image"></div>
          <div class="mid_text_box">
            <h4 class="ml10">
              <span class="text-wrapper">
                <span class="letters">DIGITAL</span>
              </span>
            </h4>
            <h5 class="ml3">MARKETING</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="left_first_box">
          <div class="new">
            <h1 class="title-slide-in" data-splitting>
              NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
            </h1>
          </div>
          <div class="video_box acc_panel anim_in">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Optional JavaScript -->
  <!-- jQuery first, then Popper.js, then Bootstrap JS -->
</body>
